import type { IHaulageJobScheduleForm } from '@/interfaces'
import Base from '../Base'

class HaulageJobScheduleForm extends Base implements IHaulageJobScheduleForm {
  vehicle: string
  employee: string
  scheduledDate: string
  description: string

  constructor(jobData?: any) {
    super(jobData)
    this.vehicle = jobData?.vehicle ?? null
    this.employee = jobData?.employee ?? null
    this.scheduledDate = jobData?.scheduledDate ?? null
    this.description = jobData?.description ?? null
  }
}

export default HaulageJobScheduleForm
